import clsx from 'clsx';
import type { JSX, ReactNode } from 'react';

export interface FormActionsProps {
  children: ReactNode;
  justify?: 'start' | 'end' | 'between';
}

export function FormActions({ children, justify = 'end' }: FormActionsProps): JSX.Element {
  return (
    <div
      className={clsx('flex gap-sm', {
        'justify-start': justify === 'start',
        'justify-end': justify === 'end',
        'justify-between': justify === 'between',
      })}
    >
      {children}
    </div>
  );
}
